module.exports = __webpack_public_path__ + "img/psstruck-nobg-small3.8a31c342.png";